var safelyParseJson=function(a){try{return JSON.parse(a)}catch(a){// @ts-ignore
return null}};export default safelyParseJson;